export const validation = {
  usage: {
    maxTwoDecimals: 'It must contain at most 2 decimals',
  },
};
